module.exports = require('./helpers/bundle-url').getBundleURL('jNzS2') + "logo-dark.eefe0b7f.svg";